<template>
  <!-- starting div -->
  <div style="margin-top:-10px;">
    <header>
      <!-- We want header content here -->
      <b-row
        class="border-bottom px-pad justify-content-center align-items-center"
        style="height:42px;"
      >
        <b-col cols="10" md="11" class="px-0">
          <h4 class="page-title mb-2">
            {{
              $route.query.type == "sales_global_export"
                ? "Total Invoice Details"
                : list.type == "b2b_return"
                ? "B2B Invoices "
                : list.type == "b2c_return"
                ? "B2C Invoices by Product"
                : list.type == "hsn_return"
                ? "Group by HSN "
                : "Total Invoice Details"
            }}
            <small class="text-muted">{{
              $route.query.type == "sales_global_export"
                ? ""
                : list.type == "b2b_return"
                ? "(Taxable outward supplies for registered persons)"
                : list.type == "b2c_return"
                ? "(Taxable outward supplies to consumers)"
                : list.type == "hsn_return"
                ? "(Has both B2B and B2C)"
                : ""
            }}</small>
          </h4>
        </b-col>
        <b-col cols="2" md="1" class="text-right px-0">
          <router-link :to="{ name: 'GSTR1Overview' }">
            <i class="la la-remove la-lg text-decoration-none text-dark mb-2"></i>
          </router-link>
        </b-col>
      </b-row>
    </header>
    <!-- Validation for gstr1 transaction  reports -->
    <b-row class="mt-4">
      <b-col xl="12" lg="12" md="12" xs="12" sm="12">
        <div class="container-fluid">
          <b-alert class="alert-transparent alert-danger" :show="error_show && this.errors.any()">
            <button type="button" @click="error_show = !error_show" class="close">
              <span aria-hidden="true">&times;</span>
            </button>

            <div v-for="item in errors.items" :key="item.id">
              <p class="fw-semi-bold">{{ item.msg }}</p>
            </div>
          </b-alert>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col xl="2" lg="3" md="3" sm="3">
        <!-- gstr1 filing option -->
        <b-form-group>
          <b-form-select
            class="form-control"
            data-vv-name="type"
            v-model.trim="gstreturn.type"
            v-validate="'required'"
            name="type"
          >
            <option value="b2b_return">B2B Invoice</option>
            <option value="b2c_return">B2C Invoice</option>
            <option value="hsn_return">HSN Invoice</option>
            <option value="total_return">Total Invoice</option>
            <option value="sales_global_export">Invoice wise sales</option>
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col xl="2" lg="3" md="3" sm="3">
        <!--  datepicker for choosing gstr1 filing month -->
        <DatePicker
          v-validate="'required'"
          lang="en"
          input-class="form-control"
          v-model.trim="gstreturn.month"
          data-vv-name="month year"
          style="width:100% !important;"
          placeholder=" "
          :name="'month_year'"
          type="month"
          :format="'YYYY-MMM'"
          @change="selectDate"
        >
          <i class="fa fa-calendar text-dark" slot="calendar-icon" />
        </DatePicker>
      </b-col>
      <b-col xl="2" lg="3" md="3" sm="3">
        <b-button
          v-if="gstreturn.type != 'sales_global_export'"
          variant="primary"
          @click="onRunReport"
          class="float-left ml-3 btn-sm"
          >Run Report</b-button
        >
      </b-col>
    </b-row>
    <b-row v-if="gstreturn.type == 'sales_global_export'">
      <b-col cols="4" md="6" class="text-left">
        <h5 class="my-3 h6-lg">Export Dump Sales Report</h5>

        <b-button-group v-if="RoutePermission(false, '', '', 'settings', 'export')">
          <downloadexcel
            class="btn excel_export btn-outline-primary"
            :fetch="fetchSalesExportData"
            :exportDatas="export_sales"
            :before-generate="startDownload"
            :before-finish="finishDownload"
            type="csv"
            :name="'Sales GST.csv'"
          >
            <span title="Export xl">CSV</span>
            <i class="fa fa-file-excel-o ml-2"></i>
          </downloadexcel>
          <downloadexcel
            class="btn excel_export btn-outline-primary"
            :fetch="fetchSalesExportData"
            :exportDatas="export_sales"
            :before-generate="startDownload"
            :before-finish="finishDownload"
            type="xls"
            :name="'Sales GST.xls'"
          >
            <span title="Export xl">XLS</span>
            <i class="fa fa-file-excel-o ml-2"></i>
          </downloadexcel>
        </b-button-group>
      </b-col>
    </b-row>
    <template v-else>
      <b-row>
        <b-col xl="6" lg="6" md="3" sm="6">
          <!-- <h4
            :class="{'mb-3' :true,'float-left':true}"
          >{{ list.type == 'b2b_return' ? 'B2B Invoices (Taxable outward supplies for registered persons)' : list.type == 'b2c_return' ? 'B2C Invoices (Taxable outward supplies to consumers) by Product' : list.type == 'hsn_return' ? 'Group by HSN ( Has both B2B and B2C)' : 'Total Invoice Details' }}</h4>-->

          <template v-if="list.list.length > 0">
            <b-button-group>
              <downloadexcel
                class="btn excel_exportxl"
                :fetch="fetchData"
                :exportDatas="
                  list.type == 'b2b_return'
                    ? b2b_fields
                    : list.type == 'b2c_return'
                    ? b2c_fields
                    : list.type == 'hsn_return'
                    ? hsn_fields
                    : total_fields
                "
                :before-generate="startDownload"
                :before-finish="finishDownload"
                type="csv"
                :name="gstreturn.type + '-' + gstreturn.month + '.xls'"
              >
                <span title="Export xl"> <i class="la la-download la-lg mr-1"></i>CSV </span>
              </downloadexcel>
              <downloadexcel
                class="btn excel_exportxl"
                :fetch="fetchData"
                :exportDatas="
                  list.type == 'b2b_return'
                    ? b2b_fields
                    : list.type == 'b2c_return'
                    ? b2c_fields
                    : list.type == 'hsn_return'
                    ? hsn_fields
                    : total_fields
                "
                :before-generate="startDownload"
                :before-finish="finishDownload"
                type="xls"
                :name="gstreturn.type + '-' + gstreturn.month + '.xls'"
              >
                <span title="Export xl"> <i class="la la-download la-lg mr-1"></i>XLS </span>
              </downloadexcel>
            </b-button-group>
          </template>
        </b-col>
      </b-row>
      <b-row v-if="list.type == 'inv_sales_return'">
        <b-col></b-col>
      </b-row>
      <template v-else>
        <b-row class="pt-4">
          <b-col
            lg="12"
            xl="12"
            md="12"
            sm="12"
            :class="list.type == 'total_return' ? 'px-pad' : 'px-0'"
          >
            <div
              class="table-responsive"
              id="reportScrollCol"
              :style="{ 'max-width': list.type == 'total_return' ? '650px' : '' }"
            >
              <!--  sales by customer Table-->
              <table
                :class="
                  list.type == 'total_return'
                    ? 'table table-bordered reports-table-border'
                    : 'table table-bordered reports-table-border table-no-bordered'
                "
              >
                <!--  sales by customer Table head-->

                <thead class="tbl-col">
                  <tr v-if="list.type == 'b2b_return'">
                    <th style="padding-left:1.5rem !important">
                      <router-link
                        class="text-dark text-decoration-none"
                        :to="{
                          name: 'GSTR1Transaction',
                          query: {
                            type: $route.query.type,
                            month: $route.query.month,
                            year: $route.query.year,
                            page: 1,
                            show: 10,
                            sort: sort == 'asc' ? 'desc' : 'asc',
                            label: 'buyer_gst_no',
                          },
                        }"
                      >
                        Customer Gst
                        <small class="text-muted" v-if="label == 'buyer_gst_no'">
                          <i
                            :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                            style="font-weight:thinner;"
                          ></i>
                        </small>
                      </router-link>
                    </th>
                    <th>
                      <router-link
                        class="text-dark text-decoration-none"
                        :to="{
                          name: 'GSTR1Transaction',
                          query: {
                            type: $route.query.type,
                            month: $route.query.month,
                            year: $route.query.year,
                            page: 1,
                            show: 10,
                            sort: sort == 'asc' ? 'desc' : 'asc',
                            label: 'created_date',
                          },
                        }"
                      >
                        Date
                        <small class="text-muted" v-if="label == 'created_date'">
                          <i
                            :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                            style="font-weight:thinner;"
                          ></i>
                        </small>
                      </router-link>
                    </th>
                    <th>
                      <router-link
                        class="text-dark text-decoration-none"
                        :to="{
                          name: 'GSTR1Transaction',
                          query: {
                            type: $route.query.type,
                            month: $route.query.month,
                            year: $route.query.year,
                            page: 1,
                            show: 10,
                            sort: sort == 'asc' ? 'desc' : 'asc',
                            label: 'inv_no',
                          },
                        }"
                      >
                        Invoice
                        <small class="text-muted" v-if="label == 'inv_no'">
                          <i
                            :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                            style="font-weight:thinner;"
                          ></i>
                        </small>
                      </router-link>
                    </th>
                    <th class="text-right">
                      <router-link
                        class="text-dark text-decoration-none"
                        :to="{
                          name: 'GSTR1Transaction',
                          query: {
                            type: $route.query.type,
                            month: $route.query.month,
                            year: $route.query.year,
                            page: 1,
                            show: 10,
                            sort: sort == 'asc' ? 'desc' : 'asc',
                            label: 'total_qty',
                          },
                        }"
                      >
                        Qty
                        <small class="text-muted" v-if="label == 'total_qty'">
                          <i
                            :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                            style="font-weight:thinner;"
                          ></i>
                        </small>
                      </router-link>
                    </th>
                    <th class="text-right">
                      <router-link
                        class="text-dark text-decoration-none"
                        :to="{
                          name: 'GSTR1Transaction',
                          query: {
                            type: $route.query.type,
                            month: $route.query.month,
                            year: $route.query.year,
                            page: 1,
                            show: 10,
                            sort: sort == 'asc' ? 'desc' : 'asc',
                            label: 'total_without_tax',
                          },
                        }"
                      >
                        Taxable Value
                        <small class="text-muted" v-if="label == 'total_without_tax'">
                          <i
                            :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                            style="font-weight:thinner;"
                          ></i>
                        </small>
                      </router-link>
                    </th>
                    <th class="text-right">
                      <router-link
                        class="text-dark text-decoration-none"
                        :to="{
                          name: 'GSTR1Transaction',
                          query: {
                            type: $route.query.type,
                            month: $route.query.month,
                            year: $route.query.year,
                            page: 1,
                            show: 10,
                            sort: sort == 'asc' ? 'desc' : 'asc',
                            label: 'sgst_tax',
                          },
                        }"
                      >
                        SGST
                        <small class="text-muted" v-if="label == 'sgst_tax'">
                          <i
                            :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                            style="font-weight:thinner;"
                          ></i>
                        </small>
                      </router-link>
                    </th>
                    <th class="text-right">
                      <router-link
                        class="text-dark text-decoration-none"
                        :to="{
                          name: 'GSTR1Transaction',
                          query: {
                            type: $route.query.type,
                            month: $route.query.month,
                            year: $route.query.year,
                            page: 1,
                            show: 10,
                            sort: sort == 'asc' ? 'desc' : 'asc',
                            label: 'cgst_tax',
                          },
                        }"
                      >
                        CGST
                        <small class="text-muted" v-if="label == 'cgst_tax'">
                          <i
                            :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                            style="font-weight:thinner;"
                          ></i>
                        </small>
                      </router-link>
                    </th>
                    <th class="text-right">
                      <router-link
                        class="text-dark text-decoration-none"
                        :to="{
                          name: 'GSTR1Transaction',
                          query: {
                            type: $route.query.type,
                            month: $route.query.month,
                            year: $route.query.year,
                            page: 1,
                            show: 10,
                            sort: sort == 'asc' ? 'desc' : 'asc',
                            label: 'igst_tax',
                          },
                        }"
                      >
                        IGST
                        <small class="text-muted" v-if="label == 'igst_tax'">
                          <i
                            :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                            style="font-weight:thinner;"
                          ></i>
                        </small>
                      </router-link>
                    </th>

                    <th class="text-right">
                      <router-link
                        class="text-dark text-decoration-none"
                        :to="{
                          name: 'GSTR1Transaction',
                          query: {
                            type: $route.query.type,
                            month: $route.query.month,
                            year: $route.query.year,
                            page: 1,
                            show: 10,
                            sort: sort == 'asc' ? 'desc' : 'asc',
                            label: 'utgst_tax',
                          },
                        }"
                      >
                        UTGST
                        <small class="text-muted" v-if="label == 'utgst_tax'">
                          <i
                            :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                            style="font-weight:thinner;"
                          ></i>
                        </small>
                      </router-link>
                    </th>
                    <th class="text-right">
                      <router-link
                        class="text-dark text-decoration-none"
                        :to="{
                          name: 'GSTR1Transaction',
                          query: {
                            type: $route.query.type,
                            month: $route.query.month,
                            year: $route.query.year,
                            page: 1,
                            show: 10,
                            sort: sort == 'asc' ? 'desc' : 'asc',
                            label: 'cess',
                          },
                        }"
                      >
                        CESS
                        <small class="text-muted" v-if="label == 'cess'">
                          <i
                            :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                            style="font-weight:thinner;"
                          ></i>
                        </small>
                      </router-link>
                    </th>
                    <th class="text-right" style="padding-right:1.5rem !important">
                      <router-link
                        class="text-dark text-decoration-none"
                        :to="{
                          name: 'GSTR1Transaction',
                          query: {
                            type: $route.query.type,
                            month: $route.query.month,
                            year: $route.query.year,
                            page: 1,
                            show: 10,
                            sort: sort == 'asc' ? 'desc' : 'asc',
                            label: 'grand_total',
                          },
                        }"
                      >
                        Invoice Value
                        <small class="text-muted" v-if="label == 'grand_total'">
                          <i
                            :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                            style="font-weight:thinner;"
                          ></i>
                        </small>
                      </router-link>
                    </th>
                  </tr>
                  <tr v-if="list.type == 'b2c_return' || list.type == 'hsn_return'">
                    <!-- <th>Product Name</th> -->
                    <th style="padding-left:1.5rem !important">
                      <router-link
                        class="text-dark text-decoration-none"
                        :to="{
                          name: 'GSTR1Transaction',
                          query: {
                            type: $route.query.type,
                            month: $route.query.month,
                            year: $route.query.year,
                            page: 1,
                            show: 10,
                            sort: sort == 'asc' ? 'desc' : 'asc',
                            label: list.type == 'hsn_return' ? 'pdt_hsn' : 'sales_tax_percent',
                          },
                        }"
                      >
                        {{ list.type == "hsn_return" ? "HSN" : "GST %" }}
                        <small
                          class="text-muted"
                          v-if="
                            (label == list.type) == 'hsn_return' ? 'pdt_hsn' : 'sales_tax_percent'
                          "
                        >
                          <i
                            :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                            style="font-weight:thinner;"
                          ></i>
                        </small>
                      </router-link>
                    </th>
                    <th class="text-right">
                      <router-link
                        class="text-dark text-decoration-none"
                        :to="{
                          name: 'GSTR1Transaction',
                          query: {
                            type: $route.query.type,
                            month: $route.query.month,
                            year: $route.query.year,
                            page: 1,
                            show: 10,
                            sort: sort == 'asc' ? 'desc' : 'asc',
                            label: 'total_pdt_qty',
                          },
                        }"
                      >
                        Qty
                        <small class="text-muted" v-if="label == 'total_pdt_qty'">
                          <i
                            :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                            style="font-weight:thinner;"
                          ></i>
                        </small>
                      </router-link>
                    </th>
                    <th class="text-right">
                      <router-link
                        class="text-dark text-decoration-none"
                        :to="{
                          name: 'GSTR1Transaction',
                          query: {
                            type: $route.query.type,
                            month: $route.query.month,
                            year: $route.query.year,
                            page: 1,
                            show: 10,
                            sort: sort == 'asc' ? 'desc' : 'asc',
                            label: 'total_subtotal_without_tax',
                          },
                        }"
                      >
                        Taxable Value
                        <small class="text-muted" v-if="label == 'total_subtotal_without_tax'">
                          <i
                            :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                            style="font-weight:thinner;"
                          ></i>
                        </small>
                      </router-link>
                    </th>
                    <th class="text-right">
                      <router-link
                        class="text-dark text-decoration-none"
                        :to="{
                          name: 'GSTR1Transaction',
                          query: {
                            type: $route.query.type,
                            month: $route.query.month,
                            year: $route.query.year,
                            page: 1,
                            show: 10,
                            sort: sort == 'asc' ? 'desc' : 'asc',
                            label: 'total_sgst',
                          },
                        }"
                      >
                        SGST
                        <small class="text-muted" v-if="label == 'total_sgst'">
                          <i
                            :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                            style="font-weight:thinner;"
                          ></i>
                        </small>
                      </router-link>
                    </th>
                    <th class="text-right">
                      <router-link
                        class="text-dark text-decoration-none"
                        :to="{
                          name: 'GSTR1Transaction',
                          query: {
                            type: $route.query.type,
                            month: $route.query.month,
                            year: $route.query.year,
                            page: 1,
                            show: 10,
                            sort: sort == 'asc' ? 'desc' : 'asc',
                            label: 'total_cgst',
                          },
                        }"
                      >
                        CGST
                        <small class="text-muted" v-if="label == 'total_cgst'">
                          <i
                            :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                            style="font-weight:thinner;"
                          ></i>
                        </small>
                      </router-link>
                    </th>
                    <th class="text-right">
                      <router-link
                        class="text-dark text-decoration-none"
                        :to="{
                          name: 'GSTR1Transaction',
                          query: {
                            type: $route.query.type,
                            month: $route.query.month,
                            year: $route.query.year,
                            page: 1,
                            show: 10,
                            sort: sort == 'asc' ? 'desc' : 'asc',
                            label: 'total_igst',
                          },
                        }"
                      >
                        IGST
                        <small class="text-muted" v-if="label == 'total_igst'">
                          <i
                            :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                            style="font-weight:thinner;"
                          ></i>
                        </small>
                      </router-link>
                    </th>
                    <th class="text-right">
                      <router-link
                        class="text-dark text-decoration-none"
                        :to="{
                          name: 'GSTR1Transaction',
                          query: {
                            type: $route.query.type,
                            month: $route.query.month,
                            year: $route.query.year,
                            page: 1,
                            show: 10,
                            sort: sort == 'asc' ? 'desc' : 'asc',
                            label: 'total_utgst',
                          },
                        }"
                      >
                        UTGST
                        <small class="text-muted" v-if="label == 'total_utgst'">
                          <i
                            :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                            style="font-weight:thinner;"
                          ></i>
                        </small>
                      </router-link>
                    </th>
                    <th class="text-right">
                      <router-link
                        class="text-dark text-decoration-none"
                        :to="{
                          name: 'GSTR1Transaction',
                          query: {
                            type: $route.query.type,
                            month: $route.query.month,
                            year: $route.query.year,
                            page: 1,
                            show: 10,
                            sort: sort == 'asc' ? 'desc' : 'asc',
                            label: 'total_cess',
                          },
                        }"
                      >
                        CESS
                        <small class="text-muted" v-if="label == 'total_cess'">
                          <i
                            :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                            style="font-weight:thinner;"
                          ></i>
                        </small>
                      </router-link>
                    </th>
                    <th class="text-right" style="padding-right:1.5rem !important">
                      <router-link
                        class="text-dark text-decoration-none"
                        :to="{
                          name: 'GSTR1Transaction',
                          query: {
                            type: $route.query.type,
                            month: $route.query.month,
                            year: $route.query.year,
                            page: 1,
                            show: 10,
                            sort: sort == 'asc' ? 'desc' : 'asc',
                            label: 'total_subtotal',
                          },
                        }"
                      >
                        Invoice Value
                        <small class="text-muted" v-if="label == 'total_subtotal'">
                          <i
                            :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                            style="font-weight:thinner;"
                          ></i>
                        </small>
                      </router-link>
                    </th>
                  </tr>
                </thead>
                <!--  Sales by Customer Table body and data -->
                <template v-if="list.type != 'total_return' && list.list.length == 0">
                  <tbody>
                    <td :colspan="$route.query.type == 'b2b_return' ? 11 : 9" class="text-center">
                      No data to display
                    </td>
                  </tbody>
                </template>
                <template v-else-if="list.type == 'b2b_return'">
                  <tbody>
                    <tr v-for="item in list.list" :key="item.inv_hdr_id">
                      <td style="padding-left:1.5rem !important">{{ item.buyer_gst_no }}</td>
                      <td>{{ getDateFormat(item.created_date) }}</td>
                      <td>{{ item.inv_no }}</td>
                      <td class="text-right">
                        {{
                          Number(item.total_qty).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        }}
                      </td>
                      <td class="text-right">
                        {{
                          orgCurrencySymbol +
                            " " +
                            Number(item.total_without_tax).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                        }}
                      </td>
                      <td class="text-right">
                        {{
                          orgCurrencySymbol +
                            " " +
                            Number(parseFloat(item.sgst_tax)).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                        }}
                      </td>
                      <td class="text-right">
                        {{
                          orgCurrencySymbol +
                            " " +
                            Number(parseFloat(item.cgst_tax)).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                        }}
                      </td>
                      <td class="text-right">
                        {{
                          orgCurrencySymbol +
                            " " +
                            Number(item.igst_tax).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                        }}
                      </td>

                      <td class="text-right">
                        {{
                          orgCurrencySymbol +
                            " " +
                            Number(item.utgst_tax).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                        }}
                      </td>
                      <td class="text-right">
                        {{
                          orgCurrencySymbol +
                            " " +
                            Number(item.cess).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                        }}
                      </td>
                      <td class="text-right" style="padding-right:1.5rem !important">
                        {{
                          orgCurrencySymbol +
                            " " +
                            Number(item.grand_total).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                        }}
                      </td>
                    </tr>
                  </tbody>
                  <tr>
                    <td
                      colspan="3"
                      class="fw-semi-bold text-right"
                      style="padding-left:1.5rem !important"
                    >
                      TOTAL
                    </td>
                    <td class="fw-semi-bold text-right">
                      {{
                        Number(list.total_amount.total_qty).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      }}
                    </td>
                    <td class="fw-semi-bold text-right">
                      {{
                        orgCurrencySymbol +
                          " " +
                          Number(list.total_amount.total_without_tax).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                      }}
                    </td>
                    <td class="fw-semi-bold text-right">
                      {{
                        orgCurrencySymbol +
                          " " +
                          Number(parseFloat(list.total_amount.total_sgst)).toLocaleString(
                            undefined,
                            { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                          )
                      }}
                    </td>
                    <td class="fw-semi-bold text-right">
                      {{
                        orgCurrencySymbol +
                          " " +
                          Number(parseFloat(list.total_amount.total_cgst)).toLocaleString(
                            undefined,
                            { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                          )
                      }}
                    </td>
                    <td class="fw-semi-bold text-right">
                      {{
                        orgCurrencySymbol +
                          " " +
                          Number(parseFloat(list.total_amount.total_igst)).toLocaleString(
                            undefined,
                            { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                          )
                      }}
                    </td>
                    <td class="fw-semi-bold text-right">
                      {{
                        orgCurrencySymbol +
                          " " +
                          Number(parseFloat(list.total_amount.total_utgst)).toLocaleString(
                            undefined,
                            { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                          )
                      }}
                    </td>
                    <td class="fw-semi-bold text-right">
                      {{
                        orgCurrencySymbol +
                          " " +
                          Number(parseFloat(list.total_amount.total_cess)).toLocaleString(
                            undefined,
                            { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                          )
                      }}
                    </td>
                    <td
                      class="fw-semi-bold text-right px-4"
                      style="padding-right:1.5rem !important"
                    >
                      {{
                        orgCurrencySymbol +
                          " " +
                          Number(list.total_amount.grand_total).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                      }}
                    </td>
                  </tr>
                </template>
                <template v-else-if="list.type == 'b2c_return' || list.type == 'hsn_return'">
                  <tbody>
                    <tr v-for="item in list.list" :key="item.inv_hdr_id">
                      <!-- <td>{{ item.pdt_name }}</td> -->
                      <td style="padding-left:1.5rem !important">
                        {{ Number(item.group_name) }} {{ list.type == "hsn_return" ? "" : "%" }}
                      </td>
                      <td class="text-right">
                        {{
                          Number(item.total_pdt_qty).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        }}
                      </td>
                      <td class="text-right">
                        {{
                          orgCurrencySymbol +
                            " " +
                            Number(item.total_subtotal_without_tax).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                        }}
                      </td>
                      <td class="text-right">
                        {{
                          orgCurrencySymbol +
                            " " +
                            Number(parseFloat(item.total_sgst)).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                        }}
                      </td>
                      <td class="text-right">
                        {{
                          orgCurrencySymbol +
                            " " +
                            Number(parseFloat(item.total_cgst)).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                        }}
                      </td>
                      <td class="text-right">
                        {{
                          orgCurrencySymbol +
                            " " +
                            Number(item.total_igst).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                        }}
                      </td>
                      <td class="text-right">
                        {{
                          orgCurrencySymbol +
                            " " +
                            Number(item.total_utgst).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                        }}
                      </td>
                      <td class="text-right">
                        {{
                          orgCurrencySymbol +
                            " " +
                            Number(item.total_cess).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                        }}
                      </td>
                      <td class="text-right" style="padding-right:1.5rem !important">
                        {{
                          orgCurrencySymbol +
                            " " +
                            Number(item.total_subtotal).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                        }}
                      </td>
                    </tr>
                    <!-- <tr>
                  <td colspan="9" class="text-center">{{  }}</td>
                    </tr>-->
                  </tbody>
                  <tr>
                    <td
                      colspan="1"
                      class="fw-semi-bold text-right"
                      style="padding-left:1.5rem !important"
                    >
                      TOTAL
                    </td>
                    <td class="fw-semi-bold text-right">
                      {{
                        Number(list.total_amount.total_pdt_qty).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      }}
                    </td>
                    <td class="fw-semi-bold text-right">
                      {{
                        orgCurrencySymbol +
                          " " +
                          Number(list.total_amount.total_subtotal_without_tax).toLocaleString(
                            undefined,
                            { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                          )
                      }}
                    </td>
                    <td class="fw-semi-bold text-right">
                      {{
                        Number(parseFloat(list.total_amount.total_sgst)).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      }}
                    </td>
                    <td class="fw-semi-bold text-right">
                      {{
                        orgCurrencySymbol +
                          " " +
                          Number(parseFloat(list.total_amount.total_cgst)).toLocaleString(
                            undefined,
                            { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                          )
                      }}
                    </td>
                    <td class="fw-semi-bold text-right">
                      {{
                        orgCurrencySymbol +
                          " " +
                          Number(parseFloat(list.total_amount.total_igst)).toLocaleString(
                            undefined,
                            { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                          )
                      }}
                    </td>
                    <td class="fw-semi-bold text-right">
                      {{
                        orgCurrencySymbol +
                          " " +
                          Number(parseFloat(list.total_amount.total_utgst)).toLocaleString(
                            undefined,
                            { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                          )
                      }}
                    </td>
                    <td class="fw-semi-bold text-right">
                      {{
                        orgCurrencySymbol +
                          " " +
                          Number(parseFloat(list.total_amount.total_cess)).toLocaleString(
                            undefined,
                            { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                          )
                      }}
                    </td>
                    <td
                      class="px-4 fw-semi-bold text-right"
                      style="padding-right:1.5rem !important"
                    >
                      {{
                        orgCurrencySymbol +
                          " " +
                          Number(list.total_amount.total_subtotal).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                      }}
                    </td>
                  </tr>
                </template>
                <template v-else-if="list.type == 'total_return'">
                  <tbody>
                    <template v-if="list.total_amount.total_count != '0'">
                      <tr>
                        <td class="fw-semi-bold">Starting Invoice No.</td>
                        <td class="fw-semi-bold text-right">
                          {{ list.total_amount.min_inv_hdr_id }}
                        </td>
                      </tr>
                      <tr>
                        <td class="fw-semi-bold">Ending Invoice No.</td>
                        <td class="fw-semi-bold text-right">
                          {{ list.total_amount.max_inv_hdr_id }}
                        </td>
                      </tr>
                      <tr>
                        <td class="fw-semi-bold">No. of Invoices Generated</td>
                        <td class="fw-semi-bold text-right">
                          {{ Number(list.total_amount.non_cancelled_inv_hdr_id) }}
                        </td>
                      </tr>
                      <tr>
                        <td class="fw-semi-bold">No. of Invoices Cancelled</td>
                        <td class="fw-semi-bold text-right">
                          {{ Number(list.total_amount.cancelled_inv_hdr_id) }}
                        </td>
                      </tr>
                      <tr>
                        <td class="fw-semi-bold">No. of Invoices</td>
                        <td class="fw-semi-bold text-right">
                          {{ Number(list.total_amount.total_count) }}
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td class="fw-semi-bold">No. of transactions</td>
                        <td class="fw-semi-bold text-center">0</td>
                      </tr>
                    </template>
                  </tbody>
                </template>
              </table>
            </div>
          </b-col>
        </b-row>
        <!-- gstr1 pagination and data showing -->
        <b-row
          v-if="list.type != 'total_return'"
          style="width: 100%;position: absolute;border-top:1px solid #e0e0e0"
          class="px-4"
        >
          <b-col cols="6" class="mt-2 pt-1 px-0">
            <nav class="float-left">
              <p>
                Showing {{ list.total_amount.total_count != 0 ? (page - 1) * list.show + 1 : 0 }} to
                {{ (page - 1) * show + list.list.length }} of
                {{ list.total_amount.total_count }} entries
                <span class="btn-group dropdown">
                  <b-dropdown
                    variant="link"
                    toggle-class="text-decoration-none"
                    size="xs"
                    :show="false"
                    :text="list.show"
                    left
                  >
                    <router-link
                      :to="{
                        name: 'GSTR1Transaction',
                        query: {
                          sort: sort,
                          label: label,
                          type: $route.query.type,
                          month: $route.query.month,
                          year: $route.query.year,
                          page: 1,
                          show: 10,
                        },
                      }"
                      class="text-decoration-none"
                    >
                      <b-dropdown-item-button class="page-link" v-if="list.show != 10"
                        >10</b-dropdown-item-button
                      >
                    </router-link>
                    <router-link
                      :to="{
                        name: 'GSTR1Transaction',
                        query: {
                          sort: sort,
                          label: label,
                          type: $route.query.type,
                          month: $route.query.month,
                          year: $route.query.year,
                          page: 1,
                          show: 25,
                        },
                      }"
                      class="text-decoration-none"
                    >
                      <b-dropdown-item-button class="page-link" v-if="list.show != 25"
                        >25</b-dropdown-item-button
                      >
                    </router-link>
                    <router-link
                      :to="{
                        name: 'GSTR1Transaction',
                        query: {
                          sort: sort,
                          label: label,
                          type: $route.query.type,
                          month: $route.query.month,
                          year: $route.query.year,
                          page: 1,
                          show: 50,
                        },
                      }"
                      class="text-decoration-none"
                    >
                      <b-dropdown-item-button class="page-link" v-if="list.show != 50"
                        >50</b-dropdown-item-button
                      >
                    </router-link>
                  </b-dropdown>
                </span>
                rows per page
              </p>
            </nav>
          </b-col>
          <b-col cols="6" class="mt-2 pt-1 px-0 d-md-block d-none">
            <nav class="float-right" v-if="list.type != 'total_return'">
              <ul class="pagination">
                <li class="page-item">
                  <template v-if="page != 1">
                    <router-link
                      class="page-link"
                      :to="{
                        name: 'GSTR1Transaction',
                        query: {
                          sort: sort,
                          label: label,
                          type: $route.query.type,
                          month: $route.query.month,
                          year: $route.query.year,
                          page: page - 1,
                          show: list.show,
                        },
                      }"
                    >
                      <span aria-hidden="true">&laquo;</span>
                      <span class="sr-only">Previous</span>
                    </router-link>
                  </template>
                  <template v-else>
                    <a class="page-link" href="#" aria-label="Previous">
                      <span aria-hidden="true">&laquo;</span>
                      <span class="sr-only">Previous</span>
                    </a>
                  </template>
                </li>
                <li class="page-item">
                  <router-link
                    class="page-link"
                    :to="{
                      name: 'GSTR1Transaction',
                      query: {
                        sort: sort,
                        label: label,
                        type: $route.query.type,
                        month: $route.query.month,
                        year: $route.query.year,
                        page: 1,
                        show: list.show,
                      },
                    }"
                    >First</router-link
                  >
                </li>
                <li class="page-item">
                  <template v-if="page != 1">
                    <router-link
                      class="page-link"
                      :to="{
                        name: 'GSTR1Transaction',
                        query: {
                          sort: sort,
                          label: label,
                          type: $route.query.type,
                          month: $route.query.month,
                          year: $route.query.year,
                          page: page - 1,
                          show: list.show,
                        },
                      }"
                      >Previous</router-link
                    >
                  </template>
                  <template v-else>
                    <a href="#" class="page-link">Previous</a>
                  </template>
                </li>
                <li class="page-item">
                  <template v-if="list.total_amount.total_count > page * list.show">
                    <router-link
                      class="page-link"
                      :to="{
                        name: 'GSTR1Transaction',
                        query: {
                          sort: sort,
                          label: label,
                          type: $route.query.type,
                          month: $route.query.month,
                          year: $route.query.year,
                          page: page + 1,
                          show: list.show,
                        },
                      }"
                      >Next</router-link
                    >
                  </template>
                  <template v-else>
                    <a href="#" class="page-link">Next</a>
                  </template>
                </li>
                <li class="page-item">
                  <router-link
                    class="page-link"
                    :to="{
                      name: 'GSTR1Transaction',
                      query: {
                        sort: sort,
                        label: label,
                        type: $route.query.type,
                        month: $route.query.month,
                        year: $route.query.year,
                        page: Math.ceil(list.total_amount.total_count / list.show),
                        show: list.show,
                      },
                    }"
                    >Last</router-link
                  >
                </li>
                <li class="page-item">
                  <template v-if="list.total_amount.total_count > page * list.show">
                    <router-link
                      class="page-link"
                      :to="{
                        name: 'GSTR1Transaction',
                        query: {
                          sort: sort,
                          label: label,
                          type: $route.query.type,
                          month: $route.query.month,
                          year: $route.query.year,
                          page: page + 1,
                          show: list.show,
                        },
                      }"
                    >
                      <span aria-hidden="true">&raquo;</span>
                      <span class="sr-only">Next</span>
                    </router-link>
                  </template>
                  <template v-else>
                    <a class="page-link" href="#" aria-label="Next">
                      <span aria-hidden="true">&raquo;</span>
                      <span class="sr-only">Next</span>
                    </a>
                  </template>
                </li>
              </ul>
            </nav>
          </b-col>
        </b-row>
      </template>
    </template>
  </div>
</template>

<script>
// import needed functions, file , components and state
import { mapState, mapGetters } from "vuex"; // data accesing from state management
import store from "@/store/index"; // to call vuex functions
import downloadexcel from "@/components/DownloadExcel/DownloadExcel"; // to excel export the output
import DatePicker from "vue2-datepicker"; // vue datepicker
import { formatDate } from "@/mixins/formatDate"; // global fucntion for calling formatDate

function getPageGstfilingOverview(routeTo, next) {
  const currentPage = parseInt(routeTo.query.page) || 1;
  const show = parseInt(routeTo.query.show) || 10;
  const label = routeTo.query.label || "";
  const sort = routeTo.query.sort || "";
  if (routeTo.query.type != "sales_global_export") {
    store
      .dispatch("gstfiling/fetchOverviewLists", {
        page: currentPage,
        show: show,
        sort: sort,
        label: label,
        query: routeTo.query,
      })
      .then(() => {
        routeTo.params.page = currentPage;
        routeTo.params.show = show;
        routeTo.params.sort = sort;
        routeTo.params.label = label;
        routeTo.params.type = routeTo.query.type;
        next();
      });
  } else {
    routeTo.params.page = currentPage;
    routeTo.params.show = show;
    routeTo.params.sort = sort;
    routeTo.params.label = label;
    routeTo.params.type = routeTo.query.type;
    next();
  }
}
export default {
  // property
  props: {
    page: {
      type: Number,
      required: true,
    },
    show: {
      type: Number,
      required: true,
    },
    label: [String, Number],
    sort: [String, Number],
  },
  // register the components to use
  components: {
    downloadexcel,
    DatePicker,
  },
  mixins: [formatDate],
  name: "GSTR1Transaction",
  data() {
    // data details for return invoice type
    return {
      loader: "",
      export_sales: {
        "Transaction Date": "view_date",
        "Customer Name": "view_name",
        Address: "view_city",
        "Transaction Type": "view_type",
        "Transation No": "view_code",
        "Customer GSTIN": "view_gst_no",
        "Customer Pan": "view_pan_no",
        "Product Name": "view_pdt_name",
        "HSN/SAC": "view_pdt_hsn",
        "Base Price": "view_unit_price",
        Quantity: "view_pdt_qty",
        UQC: "view_unit_name",
        "Discount Value": "view_discount",
        "Taxable Value": "view_taxable_value",
        "GST Tax": "view_percent",
        "Total Tax": "view_total_tax",
        "Total Value": "view_total_value",
        "IGST Tax": "view_igst_tax_percent",
        "CGST Tax": "view_cgst_tax_percent",
        "SGST Tax": "view_sgst_tax_percent",
        "UTGST Tax": "view_utgst_tax_percent",
        "CESS Tax": "view_cess_tax_percent",
        "IGST Tax Value": "view_igst_tax_total",
        "CGST Tax Value": "view_cgst_tax_total",
        "SGST Tax Value": "view_sgst_tax_total",
        "UTGST Value": "view_utgst_tax_total",
        "CESS Value": "view_cess_tax_total",
      },
      export_purchase: {
        "Transaction Date": "view_date",
        "Vendor Name": "view_name",
        Address: "view_city",
        "Transaction Type": "view_type",
        "Transation No": "view_code",
        "Vendor GSTIN": "view_gst_no",
        "Vendor Pan": "view_pan_no",
        "Product Name": "view_pdt_name",
        "HSN/SAC": "view_pdt_hsn",
        "Base Price": "view_unit_price",
        Quantity: "view_pdt_qty",
        UQC: "view_unit_name",
        "Discount Value": "view_discount",
        "Taxable Value": "view_taxable_value",
        "GST Tax": "view_percent",
        "Total Tax": "view_total_tax",
        "Total Value": "view_total_value",
        "IGST Tax": "view_igst_tax_percent",
        "CGST Tax": "view_cgst_tax_percent",
        "SGST Tax": "view_sgst_tax_percent",
        "UTGST Tax": "view_utgst_tax_percent",
        "CESS Tax": "view_cess_tax_percent",
        "IGST Tax Value": "view_igst_tax_total",
        "CGST Tax Value": "view_cgst_tax_total",
        "SGST Tax Value": "view_sgst_tax_total",
        "UTGST Value": "view_utgst_tax_total",
        "CESS Value": "view_cess_tax_total",
      },
      b2b_fields: {
        "Customer GST": "buyer_gst_no",
        Date: "created_date",
        "INV No.": "inv_no",
        Qty: "total_qty",
        "Taxable Value": "total_without_tax",
        SGST: "sgst_tax",
        CGST: "cgst_tax",
        IGST: "igst_tax",
        UTGST: "utgst_tax",
        CESS: "cess",
        "Invoice Value": "grand_total",
      },
      b2c_fields: {
        "GST %": "group_name",
        Qty: "total_pdt_qty",
        "Taxable Value": "total_subtotal_without_tax",
        SGST: "total_sgst",
        CGST: "total_cgst",
        IGST: "total_igst",
        UTGST: "total_utgst",
        CESS: "total_cess",
        "Invoice Value": "total_subtotal",
      },
      hsn_fields: {
        HSN: "group_name",
        Qty: "total_pdt_qty",
        "Taxable Value": "total_subtotal_without_tax",
        SGST: "total_sgst",
        CGST: "total_cgst",
        IGST: "total_igst",
        UTGST: "total_utgst",
        CESS: "total_cess",
        "Invoice Value": "total_subtotal",
      },
      total_fields: {
        "Invoice Details": "total_desc",
        "Invoice Value": "total_value",
      },
      error_show: false,
      gstreturn: {
        type: this.$route.query.type || "b2b_return",
        month:
          typeof this.$route.query.year != "undefined"
            ? this.formatDate(new Date(this.$route.query.year, this.$route.query.month, 0))
            : this.formatDate(new Date().getFullYear()),
      },
    };
  },
  async created() {
    if (this.inv_settings_details.pjt_field) {
      this.export_sales["Project Name"] = await "pjt_name";
    }
  },
  methods: {
    selectDate(val) {
      this.gstreturn.month =
        val == "" || typeof val == "undefined" || val == null ? "" : this.formatDate(val);
    },
    fetchSalesExportData() {
      const currentPage = parseInt(this.$route.query.page) || 1;
      const show = parseInt(this.$route.query.show) || 10;
      const response = store
        .dispatch("reports/fetchSalesgstExportLists", {
          page: currentPage,
          show: show,
          query: {
            month: new Date(this.gstreturn.month).getMonth() + 1,
            year: new Date(this.gstreturn.month).getFullYear(),
            type: this.gstreturn.type,
          },
        })
        .then(() => {
          return this.export;
        });
      return response;
    },
    fetchPurchaseExportData() {
      const currentPage = parseInt(this.$route.query.page) || 1;
      const show = parseInt(this.$route.query.show) || 10;
      const response = store
        .dispatch("reports/fetchPurchasegstExportLists", {
          page: currentPage,
          show: show,
        })
        .then(() => {
          return this.export;
        });
      return response;
    },
    async fetchData() {
      const response = await store
        .dispatch("gstfiling/fetchOverallLists", {
          query: {
            month: new Date(this.gstreturn.month).getMonth() + 1,
            year: new Date(this.gstreturn.month).getFullYear(),
            type: this.gstreturn.type,
          },
        })
        .then(() => {
          return this.excel.list;
        });
      return response;
    },
    startDownload() {
      this.loader = "Loading...";
    },
    finishDownload() {
      this.loader = "Downloaded";
    },
    // on run report get the data form api
    onRunReport() {
      this.$validator.validateAll().then((result) => {
        // check all the requoired gstreturn are presnet
        if (result) {
          // if validation succewss
          this.loader = "";

          this.$router.push({
            name: this.$route.name,
            query: {
              month: new Date(this.gstreturn.month).getMonth() + 1,
              year: new Date(this.gstreturn.month).getFullYear(),
              type: this.gstreturn.type,
            },
          });
        } else {
          this.error_show = true;
        }
      });
    },
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    getPageGstfilingOverview(routeTo, next);
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
    getPageGstfilingOverview(routeTo, next);
  },
  computed: {
    ...mapState({
      list: (state) => state.gstfiling.overview,
      excel: (state) => state.gstfiling.excel,
      export: (state) => state.reports.export,
    }),
    ...mapGetters(["orgCurrencySymbol", "inv_settings_details"]),
  },
};
</script>

<style scoped>
.excel_exportxl {
  background-color: #f8f9fa;
  /* color: #4e98ff; */
}
.text-decoration-none {
  text-decoration: none !important;
}
.table-responsive {
  overflow-x: hidden !important;
}
#reportScrollCol.table-responsive {
  height: calc(100vh - 230px) !important;
}
</style>
